"use client";
import { SearchOutlined } from "@ant-design/icons";
import { useRouter } from "next/navigation";

type SearchButtonProps = {
};

export const SearchButton: React.FC<SearchButtonProps> = ({
  ...props
}) => {
  const route = useRouter();

  const goSearch = () => {
    route.push('/search');
  }

  return (
    <SearchOutlined 
      onClick={goSearch} 
      style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: 21 }}
      className="absolute top-12 right-15 cursor-pointer" />
  );
}

